// categoryService.ts

export type CategoryEntry = {
  [x: string]: any;
  id: number;
  name: string;
  // description: string;
  // description2: string;
  // description3: string;
  icon: string | string[];
  pinIcon: string | string[];
  // videoUrls: string | string[];
  isActive: boolean;

  // pdfUrls: string | string[];
  // pdfIsActive: boolean;
  // pdfName: string;

  // pdfUrls2: string | string[];
  // pdfIsActive2: boolean;
  // pdfName2: string;

  // pdfUrls3: string | string[];
  // pdfIsActive3: boolean;
  // pdfName3: string;

  // grid1: string | string[];
  // gridThumbnail1: string | string[];
  // gridType: string;

  // grid2: string | string[];
  // gridThumbnail2: string | string[];
  // gridType2: string;

  // grid3: string | string[];
  // gridThumbnail3: string | string[];
  // gridType3: string;

  // grid4: string | string[];
  // gridThumbnail4: string | string[];
  // gridType4: string;

  // grid5: string | string[];
  // gridThumbnail5: string | string[];
  // gridType5: string;

  // grid6: string | string[];
  // gridThumbnail6: string | string[];
  // gridType6: string;

  // grid7: string | string[];
  // gridThumbnail7: string | string[];
  // gridType7: string;

  // grid8: string | string[];
  // gridThumbnail8: string | string[];
  // gridType8: string;

  // grid9: string | string[];
  // gridThumbnail9: string | string[];
  // gridType9: string;

  uploadBy: string;
  approveBy: string;
  status: string;
  statusCode: string;
  publishBy: string;
};

export const defaultCategoryEntry: CategoryEntry = {
  id: 0,
  name: "",
  // description: "",
  // description2: "",
  // description3: "",
  icon: [],
  pinIcon: [],
  // videoUrls: [],
  isActive: true,

  // pdfUrls: [],
  // pdfIsActive: false,
  // pdfName: "",

  // pdfUrls2: [],
  // pdfIsActive2: false,
  // pdfName2: "",

  // pdfUrls3: [],
  // pdfIsActive3: false,
  // pdfName3: "",

  // grid1: [],
  // gridThumbnail1: [],
  // gridType: "",

  // grid2: [],
  // gridThumbnail2: [],
  // gridType2: "",

  // grid3: [],
  // gridThumbnail3: [],
  // gridType3: "",

  // grid4: [],
  // gridThumbnail4: [],
  // gridType4: "",

  // grid5: [],
  // gridThumbnail5: [],
  // gridType5: "",

  // grid6: [],
  // gridThumbnail6: [],
  // gridType6: "",

  // grid7: [],
  // gridThumbnail7: [],
  // gridType7: "",

  // grid8: [],
  // gridThumbnail8: [],
  // gridType8: "",

  // grid9: [],
  // gridThumbnail9: [],
  // gridType9: "",

  uploadBy: "",
  approveBy: "",
  status: "",
  statusCode: "",
  publishBy: "",
};

export const createDefaultCategoryEntry = (id: number): CategoryEntry => ({
  ...defaultCategoryEntry,
  id,
});

export const removeImageByIndex = (
  imageArray: string[] | string,
  indexToRemove: number
): string[] => {
  const images = Array.isArray(imageArray)
    ? imageArray
    : imageArray
        .split(",")
        .map((img) => img.trim())
        .filter(Boolean);

  return images.filter((_, index) => index !== indexToRemove);
};

const ensureArray = (value: any): string[] => {
  if (typeof value === "string") {
    return value.split(",").map((v) => v.trim());
  } else if (Array.isArray(value)) {
    return value;
  }
  return [];
};

export const prepareCategoryEntryForEdit = (entry: any): CategoryEntry => {
  return {
    ...entry,

    icon: ensureArray(entry.icon),
    pinIcon: ensureArray(entry.pinIcon),
    // videoUrls: ensureArray(entry.videoUrls),

    // pdfUrls: ensureArray(entry.pdfUrls),
    // pdfUrls2: ensureArray(entry.pdfUrls2),
    // pdfUrls3: ensureArray(entry.pdfUrls3),

    // grid1: ensureArray(entry.grid1),
    // gridThumbnail1: ensureArray(entry.gridThumbnail1),
    // grid2: ensureArray(entry.grid2),
    // gridThumbnail2: ensureArray(entry.gridThumbnail2),
    // grid3: ensureArray(entry.grid3),
    // gridThumbnail3: ensureArray(entry.gridThumbnail3),
    // grid4: ensureArray(entry.grid4),
    // gridThumbnail4: ensureArray(entry.gridThumbnail4),
    // grid5: ensureArray(entry.grid5),
    // gridThumbnail5: ensureArray(entry.gridThumbnail5),
    // grid6: ensureArray(entry.grid6),
    // gridThumbnail6: ensureArray(entry.gridThumbnail6),
    // grid7: ensureArray(entry.grid7),
    // gridThumbnail7: ensureArray(entry.gridThumbnail7),
    // grid8: ensureArray(entry.grid8),
    // gridThumbnail8: ensureArray(entry.gridThumbnail8),
    // grid9: ensureArray(entry.grid9),
    // gridThumbnail9: ensureArray(entry.gridThumbnail9),
  };
};
